export const stateForPharmacy = (slug: any) => {
  const stateForParmacyCards =
    slug[slug.length - 2] == "aptiakebi" ||
    slug[slug.length - 1] == "aptiakebi";

  return { stateForParmacyCards: stateForParmacyCards };
};
